import React, { useState } from 'react';
import { submitLead } from '../firebase/leads';
import { isFirebaseConfigured } from '../firebase/config';

const Contact = () => {
  console.log('Contact page loaded!');
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    try {
      await submitLead({
        name: formData.name,
        email: formData.email,
        phone: formData.phone || '',
        message: `[Project type: ${formData.projectType}]\n\n${formData.message}`,
        extraFields: {
          source: 'contact_page',
          projectType: formData.projectType,
        },
      });
    } catch (err) {
      console.error(err);
      if (isFirebaseConfigured()) {
        alert('Something went wrong saving your message. Please try again or call us.');
        return;
      }
    }
    alert('Thank you for your inquiry. We will contact you soon!');
    setFormData({
      name: '',
      email: '',
      phone: '',
      projectType: '',
      message: ''
    });
  };

  const contactInfo = [
    {
      icon: 'location_on',
      title: 'Visit Our Studio',
      details: ['Babail Naka, Sanoli Road, Huda Bypass, Panipat-132103']
    },
    {
      icon: 'phone',
      title: 'Call Us',
      details: ['+918053055551', '+919813287280', 'Mon-Sat: 9AM-6PM']
    },
    {
      icon: 'email',
      title: 'Email Us',
      details: ['Jatininteriorspanipat@gmail.com', 'www.Jatininteriors.in', 'Response within 24 hours']
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="h-[400px] sm:h-[500px] md:h-[600px] relative flex items-center justify-center overflow-hidden">
        <div className="relative z-10 text-center px-4 sm:px-8">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-stone-900 mb-4 sm:mb-6 tracking-tighter">
            Get In Touch
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-stone-600 max-w-xs sm:max-w-md md:max-w-2xl mx-auto">
            Let's discuss your interior design vision and bring it to life
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-8 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 md:gap-12">
            {contactInfo.map((info, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                  <span className="material-symbols-outlined text-white text-lg sm:text-2xl">
                    {info.icon}
                  </span>
                </div>
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4 text-stone-900">{info.title}</h3>
                <div className="space-y-1 sm:space-y-2">
                  {info.details.map((detail, detailIndex) => (
                    <p key={detailIndex} className="text-stone-600 text-sm sm:text-base">{detail}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-8 md:px-16 bg-surface-container-low">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-stone-900">Start Your Project</h2>
            <p className="text-base sm:text-lg md:text-xl text-stone-600 max-w-2xl sm:max-w-3xl mx-auto">
              Tell us about your vision and we'll help you make it a reality
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6 md:space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-stone-700 font-medium mb-2 text-sm sm:text-base">
                  Full Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-lg border border-stone-300 focus:border-primary focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="Full Name"
                />
              </div>
              
              <div>
                <label className="block text-stone-700 font-medium mb-2 text-sm sm:text-base">
                  Email Address *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-lg border border-stone-300 focus:border-primary focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="Email Address"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-stone-700 font-medium mb-2 text-sm sm:text-base">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-lg border border-stone-300 focus:border-primary focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="Phone Number"
                />
              </div>
              
              <div>
                <label className="block text-stone-700 font-medium mb-2 text-sm sm:text-base">
                  Project Type *
                </label>
                <select
                  name="projectType"
                  value={formData.projectType}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-lg border border-stone-300 focus:border-primary focus:outline-none transition-colors text-sm sm:text-base"
                >
                  <option value="">Select a project type</option>
                  <option value="residential">Residential</option>
                  <option value="commercial">Commercial</option>
                  <option value="office">Office</option>
                  <option value="hospitality">Hospitality</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-stone-700 font-medium mb-2 text-sm sm:text-base">
                Project Details *
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                required
                rows={6}
                className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-lg border border-stone-300 focus:border-primary focus:outline-none transition-colors resize-none text-sm sm:text-base"
                placeholder="Project Details"
              />
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="bg-primary text-on-primary px-8 sm:px-10 md:px-12 py-3 sm:py-4 rounded-full font-bold hover:scale-105 transition-all duration-400 text-sm sm:text-base md:text-lg"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </section>

      </div>
  );
};

export default Contact;
